export default {
  components: {
    stationSelector: {
      title: '车站选择'
    },
    datePicker: {
      title: '選擇日期'
    }
  },
  dashboard: {
    title: '儀表盤'
  }
};
